import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'
import useStyle from './useStyle'

function InstancesTableOrg ({ rows, setLoading }) {
  const classes = useStyle()

  return (
    <div className={classes.root}>
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <TableHeader />
          <tbody className={classes.tableBody}>
            {rows.map((item, index) => (
              <TableItem
                listIndex={index}
                key={item.applicationInstanceId}
                item={item}
                setLoading={setLoading}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default InstancesTableOrg
